import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useAuthStore } from "../store";

const C = {
  bg:"#0A0E1A",card:"#0D1526",surface:"#111827",
  accent:"#00D4AA",gold:"#F59E0B",border:"#1e2d45",
  text:"#E8EDF5",muted:"#6b7fa3",navy:"#003366",red:"#FF4F6A"
};

const PLANS = [
  { id:"starter",    label:"Starter",          price:"15 000 FCFA/mois", msgs:"1 000 messages/mois",   color:"#00D4AA" },
  { id:"business",   label:"Business",          price:"50 000 FCFA/mois", msgs:"10 000 messages/mois",  color:"#F59E0B" },
  { id:"enterprise", label:"Enterprise",        price:"150 000 FCFA/mois",msgs:"Messages illimites",    color:"#E879F9" },
];

const OM = "699505253";
const MOMO = "679119530";

export default function BusinessApiPage() {
  const navigate = useNavigate();
  const { token: storeToken } = useAuthStore();
  const token = localStorage.getItem('access_token') || storeToken;
  const [tab, setTab] = useState("accueil");
  const [business, setBusiness] = useState(null);
  const [keys, setKeys] = useState([]);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newKey, setNewKey] = useState(null);
  const [form, setForm] = useState({
    name:"", type:"company", rccm:"", contact_phone:"",
    website:"", api_plan:"business", payment_method:"orange_money", payment_reference:""
  });
  const [regData, setRegData] = useState(null);

  const getToken = () => localStorage.getItem('access_token') || token;
  const h = () => ({ Authorization: 'Bearer ' + getToken(), 'Content-Type':'application/json' });

  useEffect(() => { loadBusiness(); }, []);

  const loadBusiness = async () => {
    try {
      const r = await fetch("/api/business/my", { headers: h() });
      const d = await r.json();
      if (d.success) { setBusiness(d.data); setTab("dashboard"); loadKeys(); loadLogs(); }
    } catch(e) {}
  };

  const loadKeys = async () => {
    const r = await fetch("/api/business/keys", { headers: h() });
    const d = await r.json();
    if (d.success) setKeys(d.data);
  };

  const loadLogs = async () => {
    const r = await fetch("/api/business/logs", { headers: h() });
    const d = await r.json();
    if (d.success) setLogs(d.data);
  };

  const register = async () => {
    if (!form.name) return toast.error("Nom requis");
    setLoading(true);
    try {
      const r = await fetch("/api/business/register", { method:"POST", headers: h(), body:JSON.stringify(form) });
      const d = await r.json();
      if (d.success) { setRegData(d); setTab("paiement"); }
      else toast.error(d.error);
    } catch(e) { toast.error("Erreur reseau"); }
    finally { setLoading(false); }
  };

  const genKey = async () => {
    setLoading(true);
    try {
      const r = await fetch("/api/business/keys/generate", { method:"POST", headers: h(), body:JSON.stringify({ name:"Cle principale" }) });
      const d = await r.json();
      if (d.success) { setNewKey(d.api_key); loadKeys(); toast.success("Cle generee !"); }
      else toast.error(d.error);
    } catch(e) { toast.error("Erreur"); }
    finally { setLoading(false); }
  };

  const revokeKey = async (keyId) => {
    await fetch("/api/business/keys/" + keyId, { method:"DELETE", headers:h });
    loadKeys(); toast.success("Cle revoquee");
  };

  const inp = (f, v) => setForm(prev => ({...prev, [f]:v}));
  const selectedPlan = PLANS.find(p => p.id === form.api_plan);

  return (
    <div style={{fontFamily:"sans-serif",background:C.bg,color:C.text,position:"fixed",inset:0,overflowY:"auto"}}>
      {/* HEADER */}
      <div style={{position:"sticky",top:0,zIndex:100,background:C.bg,borderBottom:`1px solid ${C.border}`,padding:"14px 20px",display:"flex",alignItems:"center",gap:12}}>
        <button onClick={()=>navigate(-1)} style={{background:"none",border:"none",color:C.accent,fontSize:24,cursor:"pointer"}}>&#8249;</button>
        <div style={{flex:1}}>
          <span style={{fontSize:20,fontWeight:700,color:C.accent}}>PAY</span>
          <span style={{fontSize:20,fontWeight:700,color:C.text,position:"relative",left:-5}}>CHAT</span>
          <span style={{fontSize:12,color:C.muted,marginLeft:8}}>Business API</span>
        </div>
      </div>

      <div style={{padding:"0 20px 40px"}}>

        {/* ACCUEIL - pas encore inscrit */}
        {tab === "accueil" && (
          <>
            <div style={{textAlign:"center",padding:"30px 0 20px"}}>
              <div style={{fontSize:40,marginBottom:8}}>⚙️</div>
              <div style={{fontSize:22,fontWeight:700,marginBottom:6}}>PayChat Business API</div>
              <div style={{fontSize:13,color:C.muted,marginBottom:24,lineHeight:1.7}}>
                Envoyez des messages automatiques a vos clients directement via PayChat. Notifications, rappels, promotions.
              </div>
            </div>

            {/* Avantages */}
            <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:20}}>
              <div style={{fontSize:14,fontWeight:700,color:C.accent,marginBottom:12}}>Pourquoi PayChat API ?</div>
              {[
                "SMS : 25-50 FCFA/message — PayChat API : forfait fixe",
                "Photos, documents, emojis — pas que du texte",
                "Messages livres instantanement",
                "Tableau de bord et statistiques",
                "Integration simple — documentation complete",
              ].map((a,i) => (
                <div key={i} style={{display:"flex",gap:10,marginBottom:8,alignItems:"flex-start"}}>
                  <span style={{color:C.accent}}>✓</span>
                  <span style={{fontSize:13,color:C.text}}>{a}</span>
                </div>
              ))}
            </div>

            {/* Plans */}
            <div style={{fontSize:16,fontWeight:700,marginBottom:12}}>Choisissez votre plan</div>
            {PLANS.map(p => (
              <div key={p.id} onClick={()=>inp("api_plan",p.id)}
                style={{background:form.api_plan===p.id?C.navy:C.card,border:`2px solid ${form.api_plan===p.id?p.color:C.border}`,borderRadius:14,padding:16,marginBottom:12,cursor:"pointer"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{fontSize:15,fontWeight:700,color:form.api_plan===p.id?p.color:C.text}}>{p.label}</div>
                    <div style={{fontSize:12,color:C.muted,marginTop:2}}>{p.msgs}</div>
                  </div>
                  <div style={{fontSize:15,fontWeight:700,color:p.color}}>{p.price}</div>
                </div>
              </div>
            ))}

            <button onClick={()=>setTab("inscription")}
              style={{width:"100%",background:C.accent,border:"none",borderRadius:12,padding:"14px",color:"#000",fontSize:15,fontWeight:700,cursor:"pointer",marginTop:8}}>
              Creer mon compte Business →
            </button>
          </>
        )}

        {/* INSCRIPTION */}
        {tab === "inscription" && (
          <>
            <div style={{fontSize:22,fontWeight:700,margin:"20px 0 6px"}}>Informations</div>
            <div style={{fontSize:13,color:C.muted,marginBottom:20}}>Plan selectionne : <strong style={{color:C.accent}}>{selectedPlan?.label} — {selectedPlan?.price}</strong></div>

            {[
              {label:"Nom de l organisation *", field:"name", placeholder:"Ex: Clinique Bonne Sante"},
              {label:"RCCM (optionnel)", field:"rccm", placeholder:"RC/DLA/2026/..."},
              {label:"Telephone de contact *", field:"contact_phone", placeholder:"+237 6XX XXX XXX"},
              {label:"Site web (optionnel)", field:"website", placeholder:"https://..."},
            ].map(f => (
              <div key={f.field} style={{marginBottom:16}}>
                <div style={{fontSize:13,color:C.muted,marginBottom:6}}>{f.label}</div>
                <input value={form[f.field]} onChange={e=>inp(f.field,e.target.value)}
                  placeholder={f.placeholder}
                  style={{width:"100%",background:C.card,border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 14px",color:C.text,fontSize:14,boxSizing:"border-box"}}/>
              </div>
            ))}

            <div style={{marginBottom:16}}>
              <div style={{fontSize:13,color:C.muted,marginBottom:6}}>Type d organisation *</div>
              <select value={form.type} onChange={e=>inp("type",e.target.value)}
                style={{width:"100%",background:C.card,border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 14px",color:C.text,fontSize:14}}>
                <option value="company">Entreprise / Societe</option>
                <option value="association">Association / ONG</option>
                <option value="school">Ecole / Universite</option>
                <option value="community">Communaute</option>
              </select>
            </div>

            <div style={{display:"flex",gap:10,marginTop:8}}>
              <button onClick={()=>setTab("accueil")} style={{flex:1,background:"transparent",border:`1px solid ${C.border}`,borderRadius:12,padding:"14px",color:C.text,fontSize:14,cursor:"pointer"}}>← Retour</button>
              <button onClick={register} disabled={loading}
                style={{flex:2,background:loading?"#666":C.accent,border:"none",borderRadius:12,padding:"14px",color:"#000",fontSize:15,fontWeight:700,cursor:loading?"not-allowed":"pointer"}}>
                {loading ? "Envoi..." : "Continuer →"}
              </button>
            </div>
          </>
        )}

        {/* PAIEMENT */}
        {tab === "paiement" && regData && (
          <>
            <div style={{fontSize:22,fontWeight:700,margin:"20px 0 6px"}}>Effectuez le paiement</div>
            <div style={{fontSize:13,color:C.muted,marginBottom:20}}>Votre compte est cree. Finalisez le paiement pour obtenir votre cle API.</div>

            <div style={{background:C.navy,border:`1px solid ${C.accent}`,borderRadius:14,padding:16,marginBottom:20,textAlign:"center"}}>
              <div style={{fontSize:12,color:C.muted,marginBottom:4}}>Reference de paiement</div>
              <div style={{fontSize:24,fontWeight:700,color:C.accent,letterSpacing:2}}>{regData.payment_info?.reference}</div>
              <div style={{fontSize:12,color:C.muted,marginTop:4}}>Mentionnez cette reference lors du paiement</div>
            </div>

            <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:20}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                <span style={{color:C.muted}}>Plan</span>
                <span style={{fontWeight:700}}>{selectedPlan?.label}</span>
              </div>
              <div style={{display:"flex",justifyContent:"space-between"}}>
                <span style={{color:C.muted}}>Montant</span>
                <span style={{fontSize:20,fontWeight:700,color:C.accent}}>{regData.payment_info?.montant?.toLocaleString()} FCFA</span>
              </div>
            </div>

            {/* Orange Money */}
            <div style={{background:C.card,border:"2px solid #FF6B00",borderRadius:14,padding:16,marginBottom:12}}>
              <div style={{fontSize:15,fontWeight:700,color:"#FF6B00",marginBottom:8}}>Orange Money</div>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",fontFamily:"monospace",fontSize:15,color:C.text,marginBottom:6}}>
                #150*1*1*{OM}*{regData.payment_info?.montant}#
              </div>
              <div style={{fontSize:12,color:C.muted}}>Beneficiaire : <strong style={{color:C.text}}>{OM}</strong></div>
            </div>

            {/* MTN MoMo */}
            <div style={{background:C.card,border:"2px solid #FFCC00",borderRadius:14,padding:16,marginBottom:20}}>
              <div style={{fontSize:15,fontWeight:700,color:"#FFCC00",marginBottom:8}}>MTN MoMo</div>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",fontFamily:"monospace",fontSize:15,color:C.text,marginBottom:6}}>
                *126*1*1*{MOMO}*{regData.payment_info?.montant}#
              </div>
              <div style={{fontSize:12,color:C.muted}}>Beneficiaire : <strong style={{color:C.text}}>{MOMO}</strong></div>
            </div>

            <div style={{background:"#F59E0B11",border:"1px solid #F59E0B44",borderRadius:12,padding:14,marginBottom:20}}>
              <div style={{fontSize:13,fontWeight:700,color:C.gold,marginBottom:8}}>Instructions</div>
              <div style={{fontSize:12,color:C.muted,lineHeight:1.7}}>
                1. Effectuez le paiement<br/>
                2. Envoyez WhatsApp au <strong style={{color:C.text}}>+237 697 008 362</strong> avec :<br/>
                &nbsp;&nbsp;• Reference : <strong style={{color:C.accent}}>{regData.payment_info?.reference}</strong><br/>
                &nbsp;&nbsp;• Numero de transaction Mobile Money<br/>
                3. Cle API activee sous 24h
              </div>
            </div>

            <button onClick={()=>loadBusiness()}
              style={{width:"100%",background:C.accent,border:"none",borderRadius:12,padding:"14px",color:"#000",fontSize:15,fontWeight:700,cursor:"pointer"}}>
              Verifier mon activation
            </button>
          </>
        )}

        {/* DASHBOARD */}
        {tab === "dashboard" && business && (
          <>
            <div style={{margin:"20px 0 16px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                <div style={{fontSize:18,fontWeight:700}}>{business.name}</div>
                {business.api_active
                  ? <span style={{background:"#00D4AA22",color:C.accent,border:"1px solid #00D4AA44",borderRadius:8,padding:"4px 10px",fontSize:12,fontWeight:700}}>Actif</span>
                  : <span style={{background:"#F59E0B22",color:C.gold,border:"1px solid #F59E0B44",borderRadius:8,padding:"4px 10px",fontSize:12,fontWeight:700}}>En attente</span>
                }
              </div>

              {/* Stats */}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:20}}>
                {[
                  {label:"Plan",value:business.api_plan||"—",color:C.accent},
                  {label:"Messages/mois",value:business.messages_this_month||0,color:C.gold},
                  {label:"Restants",value:business.messages_remaining===null?"Illimite":(business.messages_remaining||0),color:"#E879F9"},
                ].map((s,i) => (
                  <div key={i} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,padding:12,textAlign:"center"}}>
                    <div style={{fontSize:16,fontWeight:700,color:s.color}}>{s.value}</div>
                    <div style={{fontSize:10,color:C.muted,marginTop:4}}>{s.label}</div>
                  </div>
                ))}
              </div>

              {/* Tabs dashboard */}
              <div style={{display:"flex",gap:8,marginBottom:16}}>
                {["cles","logs","doc"].map(t => (
                  <button key={t} onClick={()=>setTab(t)}
                    style={{flex:1,background:C.card,border:`1px solid ${C.border}`,borderRadius:10,padding:"10px",color:C.text,fontSize:13,cursor:"pointer",fontWeight:600}}>
                    {t==="cles"?"Cles API":t==="logs"?"Historique":"Documentation"}
                  </button>
                ))}
              </div>
            </div>
          </>
        )}

        {/* CLES API */}
        {tab === "cles" && (
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",margin:"20px 0 16px"}}>
              <div style={{fontSize:18,fontWeight:700}}>Cles API</div>
              <button onClick={()=>setTab("dashboard")} style={{background:"none",border:"none",color:C.muted,fontSize:13,cursor:"pointer"}}>← Retour</button>
            </div>

            {newKey && (
              <div style={{background:"#00D4AA11",border:"1px solid #00D4AA",borderRadius:14,padding:16,marginBottom:16}}>
                <div style={{fontSize:13,fontWeight:700,color:C.accent,marginBottom:8}}>Votre nouvelle cle API</div>
                <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",fontFamily:"monospace",fontSize:11,color:C.text,wordBreak:"break-all",marginBottom:8}}>{newKey}</div>
                <div style={{fontSize:11,color:C.gold}}>Copiez cette cle maintenant — elle ne sera plus affichee !</div>
              </div>
            )}

            <button onClick={genKey} disabled={loading||keys.filter(k=>k.is_active).length>=3}
              style={{width:"100%",background:C.accent,border:"none",borderRadius:12,padding:"12px",color:"#000",fontSize:14,fontWeight:700,cursor:"pointer",marginBottom:16}}>
              + Generer une nouvelle cle
            </button>

            {keys.map(k => (
              <div key={k.id} style={{background:C.card,border:`1px solid ${k.is_active?C.accent:C.border}`,borderRadius:12,padding:14,marginBottom:10}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  <div>
                    <div style={{fontSize:13,fontWeight:700,color:k.is_active?C.accent:C.muted}}>{k.name}</div>
                    <div style={{fontSize:11,color:C.muted,fontFamily:"monospace",marginTop:4}}>{k.key_prefix}••••••••</div>
                    <div style={{fontSize:11,color:C.muted,marginTop:4}}>
                      {k.total_messages} messages • {k.last_used_at ? "Utilisee " + new Date(k.last_used_at).toLocaleDateString("fr-FR") : "Jamais utilisee"}
                    </div>
                  </div>
                  {k.is_active && (
                    <button onClick={()=>revokeKey(k.id)}
                      style={{background:"#FF4F6A22",border:"1px solid #FF4F6A44",borderRadius:8,padding:"6px 10px",color:C.red,fontSize:11,cursor:"pointer"}}>
                      Revoquer
                    </button>
                  )}
                </div>
              </div>
            ))}
          </>
        )}

        {/* HISTORIQUE */}
        {tab === "logs" && (
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",margin:"20px 0 16px"}}>
              <div style={{fontSize:18,fontWeight:700}}>Historique des messages</div>
              <button onClick={()=>setTab("dashboard")} style={{background:"none",border:"none",color:C.muted,fontSize:13,cursor:"pointer"}}>← Retour</button>
            </div>
            {logs.length === 0 ? (
              <div style={{textAlign:"center",padding:"40px 0",color:C.muted}}>Aucun message envoye</div>
            ) : logs.map((l,i) => (
              <div key={i} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,padding:14,marginBottom:10}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
                  <span style={{fontSize:13,fontWeight:700,color:l.status==="sent"?C.accent:C.red}}>
                    {l.status==="sent"?"✓ Envoye":"✗ "+l.status}
                  </span>
                  <span style={{fontSize:11,color:C.muted}}>{new Date(l.sent_at).toLocaleDateString("fr-FR")}</span>
                </div>
                <div style={{fontSize:12,color:C.muted}}>→ {l.recipient_phone}</div>
                <div style={{fontSize:12,color:C.text,marginTop:4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{l.content}</div>
              </div>
            ))}
          </>
        )}

        {/* DOCUMENTATION */}
        {tab === "doc" && (
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",margin:"20px 0 16px"}}>
              <div style={{fontSize:18,fontWeight:700}}>Documentation API</div>
              <button onClick={()=>setTab("dashboard")} style={{background:"none",border:"none",color:C.muted,fontSize:13,cursor:"pointer"}}>← Retour</button>
            </div>

            <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:16}}>
              <div style={{fontSize:14,fontWeight:700,color:C.accent,marginBottom:12}}>Endpoint — Envoyer un message</div>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",fontFamily:"monospace",fontSize:12,color:C.text,marginBottom:8}}>
                POST https://zenvoi.app/api/business/send
              </div>
              <div style={{fontSize:13,fontWeight:700,color:C.muted,marginBottom:8}}>Headers</div>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",fontFamily:"monospace",fontSize:11,color:C.text,marginBottom:12}}>
                {`Authorization: Bearer pck_votre_cle_api`}
              </div>
              <div style={{fontSize:13,fontWeight:700,color:C.muted,marginBottom:8}}>Body (JSON)</div>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",fontFamily:"monospace",fontSize:11,color:C.text,marginBottom:12,whiteSpace:"pre"}}>
{`{
  "recipient_phone": "+237699000000",
  "message": "Votre rendez-vous est demain a 10h"
}`}
              </div>
              <div style={{fontSize:13,fontWeight:700,color:C.muted,marginBottom:8}}>Reponse</div>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",fontFamily:"monospace",fontSize:11,color:C.text,whiteSpace:"pre"}}>
{`{
  "success": true,
  "status": "sent",
  "message": "Message envoye avec succes"
}`}
              </div>
            </div>

            <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:16}}>
              <div style={{fontSize:14,fontWeight:700,color:C.gold,marginBottom:8}}>Exemple cURL</div>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",fontFamily:"monospace",fontSize:10,color:C.text,wordBreak:"break-all"}}>
                {`curl -X POST https://zenvoi.app/api/business/send -H "Authorization: Bearer pck_..." -H "Content-Type: application/json" -d '{"recipient_phone":"+237699000000","message":"Bonjour !"}'`}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
